import { Shield } from 'lucide-react'
import { useAuth } from '@/contexts/AuthContext'

function AccessDenied() {
  return (
    <div className="flex h-full items-center justify-center p-8">
      <div className="text-center">
        <Shield className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
        <h1 className="text-2xl font-bold mb-2">Access Denied</h1>
        <p className="text-muted-foreground">You do not have permission to view this page.</p>
      </div>
    </div>
  )
}

export function AdminGuard({ children }: { children: React.ReactNode }): React.ReactElement {
  const { isAdmin } = useAuth()
  if (!isAdmin) {
    return <AccessDenied />
  }
  return <>{children}</>
}
